import { useSession } from 'next-auth/react';

import { LoadingSpinner } from '@/components/ui/loading/spinner';
import { NEXT_AUTH_STATUSES, USER_ACCESS_FEATURES } from '@/lib/constants';
import { canAccessFeature } from '@/utils/auth';

export interface AuthenticatedWrapperProps {
  children: React.ReactElement;
  fallback?: React.ReactElement;
  entitlement?: (typeof USER_ACCESS_FEATURES)[keyof typeof USER_ACCESS_FEATURES];
}

const AuthenticatedWrapper = ({ children, fallback, entitlement }: AuthenticatedWrapperProps) => {
  const { status, data: session } = useSession();

  if (session) {
    if (entitlement && !canAccessFeature(entitlement, session)) return fallback;

    return children;
  }

  if (status === NEXT_AUTH_STATUSES.LOADING) return <LoadingSpinner isVisible />;
  return fallback;
};

export { AuthenticatedWrapper };
